// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b31fd5f6","455":"0b727a1f","809":"0a1e53de","838":"05912eed"}[chunkId] + ".chunk.js";
};